import type { ReactNode } from "react";

// The settings shell (docs/09 §4; UI-LAW §4 shell chrome, §8): a secondary
// settings sidebar — headed sections of row links grouped by the scope each
// row administers — with the selected row's screen in the content pane. It
// is shell chrome, not a new page archetype: the screens inside keep their
// §4c archetypes. Presentational only; row derivation and navigation are
// owned by the feature layer (SettingsLayout) and passed in.

export interface SettingsNavRow {
  id: string;
  isActive?: boolean;
  label: string;
  onSelect: () => void;
}

export interface SettingsNavSectionItem {
  heading: string;
  rows: readonly SettingsNavRow[];
}

export interface SettingsShellProps {
  children: ReactNode;
  sections: readonly SettingsNavSectionItem[];
}

export function SettingsShell({ children, sections }: SettingsShellProps) {
  return (
    <div className="marker-settings-shell">
      <nav aria-label="Settings" className="marker-settings-shell__nav">
        {sections.map((section) => (
          <section
            className="marker-settings-shell__section"
            key={section.heading}
          >
            <div className="marker-settings-shell__heading">
              {section.heading}
            </div>
            {section.rows.map((row) => (
              <button
                aria-current={row.isActive ? "page" : undefined}
                className={
                  row.isActive
                    ? "marker-settings-shell__row marker-settings-shell__row--active"
                    : "marker-settings-shell__row"
                }
                key={row.id}
                onClick={row.onSelect}
                type="button"
              >
                {row.label}
              </button>
            ))}
          </section>
        ))}
      </nav>
      <div className="marker-settings-shell__content">{children}</div>
    </div>
  );
}
